import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

function FrContent() {
  return (
    <>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">1. Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation
          du site Cartonomie. En créant un compte ou en consultant le site, vous acceptez sans
          réserve l'intégralité des présentes CGU.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">2. Service proposé</h2>
        <p>
          Cartonomie est un service d'indexation et d'agrégation de prix de cartes Pokémon basé sur
          des ventes publiques (eBay, Cardmarket, TCGPlayer, Mercari) et des contributions
          communautaires. Le service est accessible gratuitement, avec une offre Premium optionnelle.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">3. Compte utilisateur</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>L'inscription est ouverte aux personnes physiques majeures, ou aux mineurs avec accord parental.</li>
          <li>Un seul compte par personne. Le partage d'identifiants est interdit.</li>
          <li>Vous êtes responsable de la confidentialité de votre mot de passe.</li>
          <li>Cartonomie se réserve le droit de suspendre tout compte enfreignant les CGU.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">4. Usage acceptable</h2>
        <p>L'utilisateur s'engage à ne pas :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Scraper massivement le site ou contourner les limites de débit.</li>
          <li>Publier des contenus illicites, diffamatoires ou contrefaisants.</li>
          <li>Tenter d'accéder à des comptes tiers ou aux systèmes internes.</li>
          <li>Utiliser le service pour de la manipulation de marché ou de la fraude.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">5. Abonnement Premium</h2>
        <p>
          L'offre Premium est facturée mensuellement ou annuellement via Stripe. Le renouvellement est
          automatique sauf résiliation avant la date d'échéance depuis votre compte. Conformément à
          l'article L.221-28 du Code de la consommation, vous renoncez expressément au droit de
          rétractation de 14 jours dès le début d'exécution du service Premium.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">6. Données publiées par l'utilisateur</h2>
        <p>
          En soumettant un prix de vente ou un commentaire, vous accordez à Cartonomie une licence
          non-exclusive, mondiale et gratuite pour afficher, agréger et redistribuer ces données dans
          le cadre du service.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">7. Disponibilité &amp; responsabilité</h2>
        <p>
          Cartonomie est fourni « tel quel ». Nous ne garantissons pas l'absence d'interruption ni
          l'exactitude absolue des prix. Notre responsabilité ne saurait être engagée pour des pertes
          financières liées à une décision d'achat ou de vente prise sur la base des données affichées.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">8. Résiliation</h2>
        <p>
          Vous pouvez supprimer votre compte à tout moment depuis votre tableau de bord. Cartonomie
          peut résilier l'accès en cas de violation grave des présentes CGU, sans préavis.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">9. Modifications</h2>
        <p>
          Les CGU peuvent évoluer. Les modifications substantielles sont notifiées par e-mail ou via
          un bandeau visible sur le site avec un préavis de 30 jours.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">10. Droit applicable</h2>
        <p>
          Les présentes CGU sont régies par le droit français. Tout litige relève de la compétence
          exclusive des tribunaux français, sous réserve des règles impératives de protection des
          consommateurs.
        </p>
      </section>
    </>
  );
}

function EnContent() {
  return (
    <>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">1. Service</h2>
        <p>
          Cartonomie aggregates public Pokémon card prices for indexing purposes. Use of the service
          implies full acceptance of these Terms.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">2. Accounts</h2>
        <p>
          One account per person. You are responsible for keeping your credentials safe. We may
          suspend accounts violating these Terms.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">3. Acceptable use</h2>
        <p>
          No automated scraping at scale, no unlawful content, no attempts to access third-party
          accounts or internal systems, no market manipulation or fraud.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">4. Premium subscription</h2>
        <p>
          Billed monthly or yearly via Stripe with automatic renewal. Cancel anytime from your
          account. EU consumers waive the 14-day withdrawal right upon service activation.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">5. Disclaimer</h2>
        <p>
          Cartonomie is provided "as is". We don't guarantee uptime or absolute price accuracy.
          Buying/selling decisions remain your sole responsibility.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">6. Governing law</h2>
        <p>French law applies. Mandatory consumer protections of your jurisdiction remain in force.</p>
      </section>
    </>
  );
}

export default function Terms() {
  const { i18n } = useTranslation();
  const isFr = (i18n.language || "en").toLowerCase().startsWith("fr");
  return (
    <LegalLayout
      testId="terms-page"
      title={isFr ? "Conditions Générales d'Utilisation" : "Terms of Service"}
      subtitle={isFr
        ? "Règles encadrant l'utilisation de Cartonomie."
        : "Rules governing your use of Cartonomie."}
      lastUpdated={isFr ? "Mise à jour · Février 2026" : "Updated · February 2026"}
    >
      {isFr ? <FrContent /> : <EnContent />}
    </LegalLayout>
  );
}
